import React, { Component } from "react";
import { connect } from "react-redux";
import { getAgents, updateAgent } from "../actions";
import { getAllTasks } from "../actions/taskAction";
import { Container, Row, Col, Button, Form, Table, Badge, Spinner, FormSelect, FormCheck, Modal } from "react-bootstrap";
import { getDiffSecondsFromNowVN, getShopNameById } from "../utils";
import { callAgentService } from "../actions/socketAction";

const SHOP_ID_CONFIG = {
  "GiftSymphony": "42604617",
  "ResinEpic": "40890130",
  "ANNA": "52811688"
};

const getShopNameFromAgentId = (agentId) => {
  const shopId = agentId.split('-')[0];
  const shopName = Object.entries(SHOP_ID_CONFIG).find(([_, id]) => id === shopId);
  return shopName ? shopName[0] : shopId;
};

class ScanOrders extends Component {
  state = {
    agents: [],
    loading: false,
    dateFilter: 'today', // today, yesterday, 2days, 3days, 4days, all
    agentStatuses: {}, // Map of agent_id to status
    deepScan: false, // Add deep scan state
  };

  componentDidMount() {
    this.loadAgents();
    this.loadTasks();
    this.agentsInterval = setInterval(this.loadAgents, 120000); // refresh every 2 minutes
    this.tasksInterval = setInterval(this.loadTasks, 120000); // refresh tasks every 2 minutes
  }

  componentWillUnmount() {
    clearInterval(this.agentsInterval);
    clearInterval(this.tasksInterval);
  }

  loadAgents = () => {
    this.setState({ loading: true });
    this.props.getAgents({
      agent_type: 'auto_ecom_orders'
    })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  loadTasks = () => {
    this.props.getAllTasks();
  };

  handleDateFilterChange = (e) => {
    this.setState({ dateFilter: e.target.value }, this.loadAgents); // Reload agents on filter change
  };

  handleAgentToggle = (agent) => {
    const newStatus = !this.state.agentStatuses[agent.agent_id];
    this.setState(prevState => ({
      agentStatuses: {
        ...prevState.agentStatuses,
        [agent.agent_id]: newStatus
      }
    }), () => {
      this.props.updateAgent({
        agent_id: agent.agent_id,
        status: newStatus ? 'active' : 'inactive'
      });
    });
  };

  handleScanNow = (agent) => {
    this.props.callAgentService({
      agent_id: agent.agent_id,
      agent_type: "main",
      action_data: {
        date_filter: this.state.dateFilter,
        deep_scan: this.state.deepScan
      },
      action: 'scan_orders'
    });
  };

  handleRefreshShop = (agent) => {
    this.props.callAgentService({
      agent_id: agent.agent_id,
      agent_type: "main",
      action: 'refresh_webpage'
    });
  };

  handleSendWarning = (agent) => {
    const message = "Tab quét đơn đang bị đóng. Vui lòng bật lại. Xin cảm ơn !";
    // const message = prompt('Enter warning message:', defaultMessage);
    if (message) {
      this.props.callAgentService({
        agent_id: agent.agent_id,
        agent_type: "sub",
        action: 'show_popup',
        action_data: {
          message: message
        }
      });
    }
  };

  handleExportCSV = async () => {
    const { dateFilter } = this.state;
    if (dateFilter === 'all') {
      alert('Please select a specific date range for export');
      return;
    }
    
    const dateMap = {
      'today': 'today',
      'yesterday': 'yesterday',
      '2days': '2days',
      '3days': '3days',
      '4days': '4days'
    };

    const date = dateMap[dateFilter];
    if (!date) return;

    try {
      const response = await fetch(`https://TKT1.ai:2053/api/order/export-csv?online=1&date=${date}`);
      if (!response.ok) {
        throw new Error('Export failed');
      }
      alert('Export completed successfully');
    } catch (error) {
      console.error('Export failed:', error);
      alert('Failed to export CSV');
    }
  };

  renderLastPing(lastPingData) {
    if (!lastPingData) return <Badge bg="secondary">No data</Badge>;

    const lastPingTime = new Date(lastPingData);
    const diffMinutes = Math.round((Date.now() - lastPingTime.getTime()) / 60000);
    const color = diffMinutes > 5 ? "danger" : "success";

    return (
      <Badge bg={color}>{getDiffSecondsFromNowVN(lastPingTime)}</Badge>
    );
  }

  componentWillReceiveProps(props) {
    if (props.agents) {
      const agentStatuses = {};
      props.agents.forEach(agent => {
        agentStatuses[agent.agent_id] = agent.status === 'active';
      });
      this.setState({
        agents: props.agents,
        agentStatuses
      });
    }
  }

  renderTaskStatus(status) {
    switch(status) {
      case 0:
        return <Badge bg="secondary">Pending</Badge>;
      case 1:
        return <Badge bg="primary">Running</Badge>;
      case 2:
        return <Badge bg="success">Completed</Badge>;
      case 3:
        return <Badge bg="danger">Failed</Badge>;
      default:
        return <Badge bg="secondary">Unknown</Badge>;
    }
  }

  render() {
    const { agents, loading, dateFilter, agentStatuses, deepScan } = this.state;
    const { show, onHide, tasks } = this.props;

    // Filter tasks to only show scan_orders tasks
    const scanOrderTasks = tasks ? tasks.filter(task => task.task_name === 'scan_orders') : [];

    return (
      <Modal show={show} onHide={onHide} size="xl" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Scan Orders</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container fluid>
            <Row className="mb-3">
              <Col md={3}>
                <FormSelect
                  value={dateFilter}
                  onChange={this.handleDateFilterChange}
                  className="mb-2"
                >
                  <option value="today">Hôm nay</option>
                  <option value="yesterday">Hôm qua</option>
                  <option value="2days">2 ngày trước</option>
                  <option value="3days">3 ngày trước</option>
                  <option value="4days">4 ngày trước</option>
                  <option value="all">Tất cả</option>
                </FormSelect>
              </Col>
              <Col md={3}>
                <FormCheck
                  type="checkbox"
                  id="deep-scan-checkbox"
                  label="Deep Scan"
                  checked={deepScan}
                  onChange={(e) => this.setState({ deepScan: e.target.checked })}
                  className="mb-2"
                />
              </Col>
              <Col md={3}>
                <Button
                  variant="success"
                  onClick={this.handleExportCSV}
                  disabled={dateFilter === 'all'}
                >
                  Export CSV
                </Button>
              </Col>
            </Row>
            {loading && (
              <div className="text-center mb-3">
                <Spinner animation="border" variant="primary" />
                <span className="ms-2">Đang cập nhật Agents...</span>
              </div>
            )}

            <h3 className="mb-3">Agents</h3>
            <Table striped bordered hover className="mb-4">
              <thead>
                <tr>
                  <th>Agent</th>
                  <th>ID</th>
                  <th>Last Ping</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {agents.map((agent) => (
                  <tr key={agent.agent_id}>
                    <td>{getShopNameById(agent.shop_id)}</td>
                    <td>{agent.shop_id}</td>
                    <td>{this.renderLastPing(agent.ping_time)}</td>
                    <td>
                      <FormCheck
                        className="pb-3 cursor-pointer"
                        title={agentStatuses[agent.agent_id] ? "Tắt" : "Bật"}
                        type="switch"
                        id={`agent-toggle-${agent.agent_id}`}
                        checked={agentStatuses[agent.agent_id] || false}
                        onChange={() => this.handleAgentToggle(agent)}
                      />
                    </td>
                    <td>
                      <Button
                        className="btn-sm pull-left me-2"
                        type="button"
                        variant="primary"
                        onClick={() => this.handleScanNow(agent)}
                        disabled={!agentStatuses[agent.agent_id]}
                      >
                        Scan Now
                      </Button>
                      <Button
                        className="btn-sm pull-left"
                        type="button"
                        variant="info"
                        onClick={() => this.handleRefreshShop(agent)}
                        disabled={!agentStatuses[agent.agent_id]}
                      >
                        Refresh Shop
                      </Button>
                      <Button
                        className="btn-sm pull-left ms-2"
                        type="button"
                        variant="warning"
                        onClick={() => this.handleSendWarning(agent)}
                        disabled={!agentStatuses[agent.agent_id]}
                      >
                        Send Warning
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>

            <h3 className="mb-3">Scan Orders Tasks</h3>
            <Table striped bordered hover className="mb-4">
              <thead>
                <tr>
                  <th>Task ID</th>
                  <th>Shop Name</th>
                  <th>Agent ID</th>
                  <th>Date Filter</th>
                  <th>Start Time</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {scanOrderTasks.map((task) => (
                  <tr key={task._id}>
                    <td>{task._id}</td>
                    <td>{getShopNameFromAgentId(task.agent_id)}</td>
                    <td>{task.agent_id}</td>
                    <td>{JSON.parse(task.task_content).date_filter}</td>
                    <td>{new Date(task.start_time).toLocaleString()}</td>
                    <td>{this.renderTaskStatus(task.status)}</td>
                  </tr>
                ))}
                {scanOrderTasks.length === 0 && (
                  <tr>
                    <td colSpan="6" className="text-center">No scan orders tasks found</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    agents: state.agentReducer.agents,
    tasks: state.taskReducer.tasks
  };
};

export default connect(mapStateToProps, {
  getAgents,
  updateAgent,
  callAgentService,
  getAllTasks
})(ScanOrders); 